module.exports = __webpack_public_path__ + "img/Path 5.1eabc1d4.svg";